<template>
    <div class="input-container">
        <div class="input-wrapper" :class="[{focus: isFocused}, {'input-error': errorMessage}, {'info-text': infoMessage} , {required}]">
            <label v-if="label" for="cc-number" :class="[{'float-label': isFocused || value}, design]">
                {{ label }}<span v-if="required">*</span>
            </label>
			<svg width="32px" height="32px" viewBox="0 0 40 40" class="credit-card-icon">
                <g v-if="creditCardType === 'AMEX'">
                    <path clip-rule="evenodd" d="M34,9.5H6c-1.1,0-2,0.9-2,2v17c0,1.1,0.9,2,2,2h28      c1.1,0,2-0.9,2-2v-17C36,10.4,35.1,9.5,34,9.5z" fill="#3498D8" fill-rule="evenodd"/>
                    <path clip-rule="evenodd" d="M10.7,20.3h1.6l-0.8-2L10.7,20.3z M33,16.5h-4.1l-1,1.1      l-0.9-1.1h-8.7l-0.8,1.8l-0.8-1.8h-3.5v0.8l-0.4-0.8h-3l-2.9,7h3.5l0.4-1.1h1l0.4,1.1h3.9v-0.8l0.3,0.8h2l0.3-0.9v0.9h8l1-1.1      l0.9,1.1l4.1,0L30.1,20L33,16.5z M20.9,22.5h-1.1l0-3.9l-1.7,3.9h-1l-1.7-3.9v3.9h-2.3l-0.4-1.1h-2.4l-0.4,1.1H8.6l2.1-5h1.7      l1.9,4.7v-4.7h1.9l1.5,3.4l1.4-3.4h1.9V22.5z M30.8,22.5h-1.5L28,20.8l-1.5,1.7h-4.5v-5h4.6l1.4,1.6l1.5-1.6h1.4L28.7,20      L30.8,22.5z M23.1,18.5v0.9h2.5v1h-2.5v1h2.8l1.3-1.5L26,18.5H23.1z" fill="#FFFFFF" fill-rule="evenodd"/>
                </g>
                <g v-else-if="creditCardType === 'DISC'">
                    <path clip-rule="evenodd" d="M34,9.5H6c-1.1,0-2,0.9-2,2v17c0,1.1,0.9,2,2,2h28      c1.1,0,2-0.9,2-2v-17C36,10.4,35.1,9.5,34,9.5z" fill="#ECF0F1" fill-rule="evenodd"/>
                    <path clip-rule="evenodd" d="M18.5,30.5H34c1.1,0,2-0.9,2-2v-6.6C31,26.1,25.1,29,18.5,30.5      z" fill="#E67E22" fill-rule="evenodd"/>
                    <path clip-rule="evenodd" d="M13.5,17.5c-0.3-0.3-0.7-0.5-1.2-0.6c-0.5-0.1-0.9-0.2-1.4-0.2      H8v6.7h2.7c0.4,0,0.9-0.1,1.4-0.2c0.5-0.1,0.9-0.3,1.3-0.6c0.4-0.3,0.7-0.6,0.9-1c0.2-0.4,0.4-0.9,0.4-1.5      c0-0.6-0.1-1.1-0.3-1.5C14.1,18.1,13.8,17.8,13.5,17.5z M13,21c-0.2,0.3-0.4,0.5-0.6,0.7c-0.3,0.2-0.6,0.3-1,0.4      c-0.4,0.1-0.8,0.1-1.2,0.1h-1v-4.5h1.2c0.4,0,0.8,0,1.1,0.1s0.6,0.2,0.9,0.4c0.2,0.2,0.4,0.4,0.6,0.7s0.2,0.6,0.2,1      C13.3,20.4,13.2,20.8,13,21z M15.9,23.3h1.3v-6.7h-1.3V23.3z M29.9,21.6c-0.2,0.3-0.5,0.5-0.8,0.6c-0.3,0.1-0.6,0.2-0.9,0.2      c-0.4,0-0.7-0.1-1-0.2c-0.3-0.1-0.6-0.3-0.8-0.5s-0.4-0.5-0.5-0.8c-0.1-0.3-0.2-0.6-0.2-1c0-0.3,0.1-0.6,0.2-0.9      s0.3-0.5,0.5-0.8s0.5-0.4,0.8-0.5c0.3-0.1,0.7-0.2,1-0.2c0.3,0,0.5,0,0.8,0.1c0.3,0.1,0.5,0.3,0.8,0.5l1-0.7      c-0.4-0.4-0.8-0.7-1.2-0.8c-0.4-0.2-0.9-0.2-1.4-0.2c-0.6,0-1.1,0.1-1.6,0.2c-0.5,0.2-0.9,0.4-1.2,0.7c-0.3,0.3-0.6,0.7-0.8,1.1      s-0.3,0.9-0.3,1.5c0,0.5,0.1,1,0.3,1.4c0.2,0.4,0.5,0.8,0.8,1.1c0.3,0.3,0.8,0.5,1.2,0.7c0.5,0.2,1,0.2,1.6,0.2      c0.5,0,1.1-0.1,1.5-0.3c0.5-0.2,0.9-0.5,1.2-0.9L29.9,21.6z M30.8,17.6C30.5,17.2,30.8,17.6,30.8,17.6L30.8,17.6z M22.5,19.8      c-0.3-0.1-0.5-0.3-0.8-0.3c-0.3-0.1-0.6-0.2-0.8-0.3c-0.3-0.1-0.5-0.2-0.6-0.3c-0.2-0.1-0.3-0.3-0.3-0.5c0-0.2,0-0.3,0.1-0.4      c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.1,0.4-0.2c0.1,0,0.3,0,0.4,0c0.3,0,0.5,0,0.7,0.1c0.2,0.1,0.4,0.2,0.6,0.4l1-0.9      c-0.3-0.2-0.6-0.4-1-0.5c-0.4-0.1-0.7-0.2-1.1-0.2c-0.3,0-0.7,0-1,0.1c-0.3,0.1-0.6,0.2-0.9,0.4c-0.3,0.2-0.5,0.4-0.6,0.6      c-0.2,0.3-0.2,0.5-0.2,0.9c0,0.4,0.1,0.7,0.3,0.9s0.4,0.4,0.6,0.6c0.3,0.1,0.5,0.3,0.8,0.3c0.3,0.1,0.6,0.2,0.8,0.3      c0.3,0.1,0.5,0.2,0.6,0.3c0.2,0.1,0.3,0.3,0.3,0.6c0,0.2,0,0.3-0.1,0.4c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.3,0.1-0.4,0.2      c-0.2,0-0.3,0.1-0.5,0.1c-0.3,0-0.6-0.1-0.8-0.2c-0.3-0.1-0.5-0.3-0.6-0.5l-1,0.9c0.3,0.3,0.7,0.6,1.1,0.7      c0.4,0.1,0.9,0.2,1.3,0.2c0.4,0,0.7,0,1-0.1c0.3-0.1,0.6-0.2,0.9-0.4s0.4-0.4,0.6-0.7c0.1-0.3,0.2-0.6,0.2-0.9      c0-0.4-0.1-0.7-0.3-1S22.7,20,22.5,19.8z M23.4,17.2C23.4,17.2,23.1,16.9,23.4,17.2L23.4,17.2z" fill="#34495E" fill-rule="evenodd"/>
                </g>
                <g v-else-if="creditCardType === 'MC'">
                    <path clip-rule="evenodd" d="M34,9.5H6c-1.1,0-2,0.9-2,2v17c0,1.1,0.9,2,2,2h28      c1.1,0,2-0.9,2-2v-17C36,10.4,35.1,9.5,34,9.5z" fill="#34495E" fill-rule="evenodd"/>
                    <circle clip-rule="evenodd" cx="16" cy="20" fill="#E74C3C" fill-rule="evenodd" r="7"/>
                    <circle clip-rule="evenodd" cx="24" cy="20" fill="#F1C40F" fill-rule="evenodd" r="7"/>
                    <path clip-rule="evenodd" d="M21.8,16.5h-5.6c-0.2,0.3-0.4,0.6-0.6,1h6.8      C22.2,17.1,22,16.8,21.8,16.5z M20.2,14.5h-2.3c-0.3,0.3-0.6,0.6-0.9,1h4.2C20.8,15.1,20.4,14.8,20.2,14.5z M22.8,18.5h-7.5      c-0.1,0.3-0.2,0.7-0.2,1H23C22.9,19.2,22.9,18.8,22.8,18.5z M16.2,23.5h5.6c0.2-0.3,0.4-0.6,0.6-1h-6.8      C15.8,22.9,16,23.2,16.2,23.5z M15.2,21.5h7.5c0.1-0.3,0.2-0.7,0.2-1H15C15.1,20.8,15.1,21.2,15.2,21.5z M17.8,25.5h2.3      c0.3-0.3,0.6-0.6,0.9-1h-4.2C17.2,24.9,17.6,25.2,17.8,25.5z" fill="#E74C3C" fill-rule="evenodd"/>
                </g>
                <g v-else-if="creditCardType === 'VISA'">
                    <path clip-rule="evenodd" d="M34,9.5H6c-1.1,0-2,0.9-2,2v17c0,1.1,0.9,2,2,2h28      c1.1,0,2-0.9,2-2v-17C36,10.4,35.1,9.5,34,9.5z" fill="#ECF0F1" fill-rule="evenodd"/>
                    <path clip-rule="evenodd" d="M34,9.5H6c-1.1,0-2,0.9-2,2v2h32v-2C36,10.4,35.1,9.5,34,9.5z" fill="#34495E" fill-rule="evenodd"/>
                    <path clip-rule="evenodd" d="M4,26.5v2c0,1.1,0.9,2,2,2h28c1.1,0,2-0.9,2-2v-2H4z" fill="#F1C40F" fill-rule="evenodd"/>
                    <path clip-rule="evenodd" d="M22.5,19.2c-0.7-0.4-1.1-0.6-1.1-1c0-0.3,0.4-0.7,1.1-0.7      c0.6,0,1.1,0.1,1.5,0.3l0.2,0.1l0.3-1.7c-0.4-0.2-1-0.3-1.7-0.3c-1.9,0-3.3,1.1-3.3,2.6c0,1.1,1,1.7,1.7,2.1c0.8,0.4,1,0.6,1,1      c0,0.5-0.6,0.8-1.2,0.8c-0.8,0-1.2-0.1-1.8-0.4l-0.3-0.1l-0.3,1.7c0.5,0.2,1.3,0.4,2.2,0.4c2,0,3.4-1,3.4-2.6      C24.2,20.4,23.7,19.7,22.5,19.2z M29.4,16.1h-1.5c-0.5,0-0.8,0.1-1,0.6L24,23.8h2c0,0,0.3-1,0.4-1.2c0.2,0,2.2,0,2.5,0      c0.1,0.3,0.2,1.2,0.2,1.2H31L29.4,16.1z M27,21.1c0.2-0.4,0.8-2.2,0.8-2.2c0,0,0.2-0.4,0.3-0.7l0.1,0.7c0,0,0.4,1.8,0.4,2.2H27z       M15.5,23.8h1.9l1.2-7.7h-1.9L15.5,23.8z M13.8,16.1l-1.9,5.3l-0.2-1.1c-0.4-1.2-1.5-2.6-2.7-3.3l1.7,6.8l2.1,0l3.1-7.7H13.8z" fill="#34495E" fill-rule="evenodd"/>
                    <path clip-rule="evenodd" d="M11,16.7c-0.1-0.5-0.5-0.6-0.9-0.7H7l0,0.2      c2.4,0.6,4.1,2.2,4.7,4.1L11,16.7z" fill="#F1C40F" fill-rule="evenodd"/>
                </g>
                <path v-else d="M31.25,10 C33.3210678,10 35,11.65918 35,13.7058824 L35,27.2941176 C35,29.34082 33.3210678,31 31.25,31 L8.75,31 C6.67893219,31 5,29.34082 5,27.2941176 L5,13.7058824 C5,11.65918 6.67893219,10 8.75,10 L31.25,10 Z M8.75,12.4705882 C8.05964406,12.4705882 7.5,13.0236483 7.5,13.7058824 L7.5,14.9411765 C7.5,15.2822935 7.77982203,15.5588235 8.125,15.5588235 L31.875,15.5588235 C32.220178,15.5588235 32.5,15.2822935 32.5,14.9411765 L32.5,13.7058824 C32.5,13.0236483 31.9403559,12.4705882 31.25,12.4705882 L8.75,12.4705882 Z M31.25,28.5294118 C31.9403559,28.5294118 32.5,27.9763517 32.5,27.2941176 L32.5,19.8823529 C32.5,19.5412359 32.220178,19.2647059 31.875,19.2647059 L8.125,19.2647059 C7.77982203,19.2647059 7.5,19.5412359 7.5,19.8823529 L7.5,27.2941176 C7.5,27.9763517 8.05964406,28.5294118 8.75,28.5294118 L31.25,28.5294118 Z M15,23.5882353 C15.6903559,23.5882353 16.25,24.1412953 16.25,24.8235294 C16.25,25.5057635 15.6903559,26.0588235 15,26.0588235 L11.25,26.0588235 C10.5596441,26.0588235 10,25.5057635 10,24.8235294 C10,24.1412953 10.5596441,23.5882353 11.25,23.5882353 L15,23.5882353 Z"  fill="#2E2E2E" fill-rule="nonzero"></path>
            </svg>
			<input
                dusk="credit-card-input"
	            type="number"
                :maxlength="maxLength"
                name="cc-number"
                autocomplete="cc-number"
                id="cc-number"
                v-model="inputValue"
                @blur="setBlur"
                @focus="setFocus"
                :class="design"
                :required="required"
			/>
			<svg v-if="errorMessage.length" viewBox="0 0 24 24" class="error-icon">
				<path d="M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"/>
			</svg>
			<p v-if="errorMessage.length" :class="['error-message', design]">{{ errorMessage }}</p>
			<p v-if="infoMessage.length" :class="['info-message', design]">{{ infoMessage }}</p>
		</div>
	</div>
</template>
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Emit, Model } from 'vue-property-decorator';

@Component
export default class CreditCardInput extends Vue
{
    @Model('input', {type: String})         readonly value!: string;
    @Prop(Number)                           readonly maxLength!: number;
    @Prop(String)                           readonly label!: string;
	@Prop(String)                           readonly placeholder!: string;
	@Prop(String)							readonly type!: string;
    @Prop({type: String, default: ''})      readonly errorMessage!: string;
    @Prop({type: String, default: ''})      readonly infoMessage!: string;
	@Prop({type: Boolean, default: false})  readonly required!: boolean;
    @Prop({type: String, default: 'boxed'}) readonly design!: string;

    isFocused: boolean = false;

    @Emit('focus')
    public setFocus() {
        this.isFocused = true;
    }

    @Emit('blur')
    public setBlur() {
        this.isFocused = false;
    }

    get inputValue() {
        return this.value;
    }

	get creditCardType() {
		return this.type;
	}

    set inputValue(value: string) {
        this.$emit('change', value);
    }
}
</script>
<style lang="scss" scoped>
@import '~foundation-sites/scss/foundation';
@import '~scss/front/settings';

.input-container {
    font-family: $body-font-family;
    color: $body-font-color;
    font-size: $body-font-size;
}

label {
    margin-bottom: 10px;
    position: absolute;
    top: 20px;
    left: 50px;
    transition: top .3s ease, font-size .3s ease;
    padding: 0 4px;
    pointer-events: none;
    font-size: 1rem;
    line-height: 1rem;
    color: var(--battleship-gray);
    will-change: top, font-size;
}

.credit-card-icon {
	position: absolute;
	top: 12px;
	left: 14px;
}

input {
    border-radius: var(--global-radius);
    font-weight: 500;
    color: var(--dark-gray);
    padding: 16px 8px 0px 52px;
    box-shadow: none;
    margin-bottom: 22px; //keep space for error message
    border: 1px solid var(--medium-gray);
 	height: 56px;

    &.underline {
        padding: 16px 0px 0px 4px;
        border: 0;
        border-radius: 0;
        border-bottom: 1px solid var(--medium-gray);
    }

    &::placeholder {
        color: var(--gray);
        font-weight: 400;
    }


    &:hover {
        cursor: pointer;
        background-color: var(--almost-white);
    }
}

.focus {
    input {
        border: 2px solid var(--primary);
        box-shadow: none;
        padding-left: 51px; // prevent shifts of the content due to change of border width

        &.underline {
            padding-top: 17px;
            padding-left: 4px;
            border: 0;
            border-bottom: 2px solid var(--primary);
        }
    }
    & .float-label {
        color: var(--gray);
        &.underline {
            color: var(--primary);
        }
    }
}

.float-label {
    top: 11px;
    color: var(--battleship-gray);
    font-size: .75rem;
    transition: top .2s ease, font-size .2s ease;

    &.underline {
        color: var(--primary);
    }
}

.input-error {
    label.float-label {
        color: var(--alert);
    }
    input {
        border: 2px solid var(--alert);
        padding-left: 51px; // prevent shifts of the content due to change of border width
        margin-bottom: 0;

        &.underline {
            padding-top: 17px;
            padding-left: 4px;
            border: 0;
            border-bottom: 2px solid var(--alert);
        }
    }
    margin-bottom: 10px;
}

.info-text {
    input, textarea {
        margin-bottom: 0;
    }
    margin-bottom: 10px;
}

.error-message {
    font-size: .7rem;
    margin-left: 12px;
    margin-top: 5px;
    color: var(--alert);
    margin-bottom: 0;

    &.underline {
        margin-left: 4px;
    }
}

.info-message {
    font-size: .7rem;
    margin-left: 12px;
    margin-top: 5px;
    color: var(--battleship-gray);
    margin-bottom: 0;
}

.input-wrapper {
    position: relative;
}

.error-icon {
    position: absolute;
    top: 16px;
    right: 10px;
    width: 24px;

    path {
        fill: var(--alert);
    }
}

// remove yellow background on autofill
input:-webkit-autofill {
    transition-delay: 9999s;
    transition-property: background-color, color;
    &:hover,
    &:focus,
    &:active {
        transition-delay: 9999s;
        transition-property: background-color, color;
    }
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

</style>